import { v4 as uuidv4 } from 'uuid';
import { colorUtil } from "../../util/ColorUtil";

export const CircleIcon = (props: {
  width: string;
  height: string;
  isSelected?: boolean;
  color?: string;
}) => {
  const filterId = uuidv4();
  const {
    isSelected = false,
    width,
    height,
    color = colorUtil.circleIcon,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
    <g filter={`url(#${filterId})`}>
        <circle cx="25" cy="21" r="21" fill={colorUtil.white} />
        <circle cx="25" cy="21" r="19.5" stroke={color} strokeWidth="3" />
        {isSelected && <circle cx="25" cy="21" r="13" fill={color} />}
      </g>
      <defs>
        <filter
          id={filterId}
          x="0"
          y="0"
          width="50"
          height="50"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3_633"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3_633"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
